import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"down\"><defs><style type=\"text/css\"></style></defs><path d=\"M76.4 290.3c-17.5 17.5-17.5 45.8 0 63.3l370.2 370.2c35 35 91.7 35 126.6 0l372.9-372.9c17.3-17.3 17.5-45.3 0.5-62.8-17.4-17.9-46.1-18.1-63.8-0.5L541.6 628.9c-17.5 17.5-45.8 17.5-63.3 0L139.8 290.3c-17.5-17.4-45.9-17.4-63.4 0z\" p-id=\"1917\" fill=\"#bfbfbf\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/down.svg
// module id = c1xO
// module chunks = 37